module.exports = __webpack_public_path__ + "media/gift_cards/card-100-9f828633.png";